module.exports = __webpack_public_path__ + "static/hero-rocket-365dbd03c6865d91cef4769193fa65c7.png";